import styled from 'styled-components';

export const ActionLog = styled.div`
  border-bottom: 1px solid #ccc;
  padding-bottom: 8px;
  margin-bottom: 8px;
  &:last-child {
    border-bottom: 0 none;
  }
`;

export const PersonImg = styled.img`
  display: block;
  float: left;
  margin-right: 8px;
  width: 32px;
  height: 32px;
`;

export const WorkLinkIcon = styled.span`
  margin-left: 16px;
`;
